/* istanbul ignore file */
import React from 'react';
import DesktopMenu from './DesktopMenu';
import { MAX_LG_WIDTH, useDeviceDetectorService } from '../../../../utils';

const HeaderMenuItems = () => {
  const { isDesktop } = useDeviceDetectorService({ maxWidth: MAX_LG_WIDTH, defaultValue: false });

  return isDesktop ? <DesktopMenu /> : null;
};

export default HeaderMenuItems;
